import React, {useMemo} from "react"
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";

import {
    useReactTable,
    getCoreRowModel,
} from '@tanstack/react-table'

import DataTable from "../../components/DataTable";
import WorkgroupCol from "../../components/columns/WorkgroupCol";

import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Icon from "@mui/material/Icon";


const WorkgroupsTable = ({rows, page_count=-1, pagination, setPagination, onGlobalFilterChange, sorting, onSortingChange, dataTableId}) => {

    const {t} = useTranslation(["workgroups"]);

    const columns = useMemo(
        () => [
            {
                accessorKey: 'name',
                cell: props => <WorkgroupCol workgroup={props.row?.original} />,
                header: () => <span>{t("table.name")}</span>,
                enableSorting: true,
                footer: props => props.column.id,
            },
            {
                accessorKey: 'visibility',
                cell: info => t(`enums:workgroupVisibility.${info.getValue()}`),
                header: () => <span>{t("table.visibility")}</span>,
                enableSorting: false,
                footer: props => props.column.id,
                meta: {
                    width: "7rem",
                    align: "center"
                }
            },
            {
                accessorKey: 'Actions',
                cell: props => <ActionCol row={props.row}/>,
                header: () => <span>{t("table.actions")}</span>,
                enableSorting: false,
                footer: props => props.column.id,
                meta: {
                    align: 'right',
                }
            },
        ],
        []  // eslint-disable-line react-hooks/exhaustive-deps
    )

    const defaultData = useMemo(() => [], [])

    const table = useReactTable({
        data: rows ?? defaultData,
        columns,
        pageCount: page_count ?? -1,
        state: {
            pagination,
            sorting,
        },
        onPaginationChange: setPagination,
        onGlobalFilterChange: onGlobalFilterChange,
        onSortingChange: onSortingChange,
        getCoreRowModel: getCoreRowModel(),
        manualPagination: true,  // rows are expected to be paginated (controlled mode)
        manualSorting: true,  // rows are expected to be sorted (controlled mode)
        // getPaginationRowModel: getPaginationRowModel(), // If only doing manual pagination, you don't need this
        debugTable: true,
    })

    return <DataTable dataTableId={dataTableId} table={table} canSearch/>
}

const ActionCol = ({row}) => {
    const navigate = useNavigate();
    const {id} = row.original;
    return <Stack direction="row" spacing={1} justifyContent="end">
        <IconButton onClick={() => navigate(`/workgroups/${id}`)}>
            <Icon fontSize="small">edit</Icon>
        </IconButton>
    </Stack>
}

export default WorkgroupsTable;